import React from 'react';
import sustainabilityImage_avif from '../Photos/Env.avif';
import sustainabilityImage_webp from '../Photos/Env.webp';
import sustainabilityImage from '../Photos/Env.jpg';
import './Sustainability.css';
import WhatsAppButton from '../Components/WhatsAppButton';

function SustainabilityPage() {
  return (
    <main className="bg-zinc-900 text-white p-4 md:p-8 my-10">
      <div className="rounded-xl shadow-lg overflow-hidden md:flex">
        <div className="md:w-1/2">
          <picture>
            <source srcSet={sustainabilityImage_avif} type="image/avif" />
            <source srcSet={sustainabilityImage_webp} type="image/webp" />
            <img src={sustainabilityImage} alt="Environmental Stewardship" className="h-64 w-full object-cover md:h-full"/>
          </picture>
        </div>
        <div className="md:w-1/2 p-6 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold accent-red mb-4">
            Sustainability
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-neutral-300 mb-6">
            Our Commitment to the Environment
          </h2>
          <div className="space-y-5 text-neutral-400 leading-relaxed">
            <p>
              Situated alongside the picturesque Marievale Bird Sanctuary, a world-recognized RAMSAR site, Nigel Brick and Clay understands the importance of environmental stewardship. As proud members of the Blesbokspruit Environmental Forum, we prioritize eco-friendly practices and sustainable manufacturing processes. Our dedication to minimizing our environmental footprint extends to every aspect of our operations.
            </p>
            <p>
              Nigel Brick and Clay is a proud member of the Clay Brick Association, a governing body that promotes responsible clay brick manufacture and educates on sustainable production methods and energy-efficient building designs. Through our affiliation, we stay informed about the latest industry standards and advancements, ensuring that our products adhere to the highest quality and sustainability benchmarks.
            </p>
          </div>
        </div>
      </div>
      <WhatsAppButton />
    </main>
  );
}

export default SustainabilityPage;